import React from 'react';

export default function Overview() {
  return <div className="p-10">Overview</div>;
}
